import { render, staticRenderFns } from "./Glasses.vue?vue&type=template&id=db0ed3c6&"
import script from "./Glasses.vue?vue&type=script&lang=ts&"
export * from "./Glasses.vue?vue&type=script&lang=ts&"
import style0 from "./Glasses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports